module.exports = __webpack_public_path__ + "res/ic_menu_digital_display.c42e997e9a9fb8c8aa017a36063a01cb.png";